export const deepCopy = (source) => {
    const sourceCopy = source instanceof Array ? [] : {};
    for (let key in source) {
        if (source[key] instanceof Object) {
            sourceCopy[key] = deepCopy(source[key]);
        } else {
            sourceCopy[key] = source[key];
        }
    }
    return sourceCopy;
}